<div class="container mt-4">
  <div class="row">
      <div class="col-md-12">
          <div class="card">
              <div class="d-flex justify-content-between card-header">
                  <h5>{{ 'Assessment KPIs' | translate }}</h5>
                  <!-- Job Position Filter -->
                  <div class="filter-container mb-4">
                    <label for="">{{ 'Filter by job description' | translate }}</label>
                    <ng-select id="jobPositionFilter" [(ngModel)]="selectedJobPosition" (change)="onJobPositionChange()">
                      <ng-option *ngFor="let job of jobPositions" [value]="job">{{ job }}</ng-option>
                    </ng-select>
                  </div>
              </div>
              <div class="card-body">
                  <div class="row">
                      <div class="col-md-12">
                          <div class="row">
                              <div class="col-md-12 mb-4" *ngFor="let job of filteredData">
                                <div class="kpi-card">
                                  <h5>{{ job.job_position }}</h5>
                                
                                  <div class="d-flex flex-column skills-list">
                                    <!-- Required Skills -->
                                    <h6>{{ 'Required Skills' | translate }}</h6>
                                    <div>
                                      <div *ngIf="job.required_skills?.length > 0; else noRequiredSkills">
                                        <div *ngFor="let skill of job.required_skills" class="d-flex align-items-center">
                                          <i class="fas fa-check-circle text-success mr-2"></i>&nbsp;
                                          <span>{{ skill.name }}</span>
                                        </div>
                                      </div>
                                      <ng-template #noRequiredSkills>
                                        <p class="text-muted">{{ 'No skills found' | translate }}</p>
                                      </ng-template>
                                    </div>
                                
                                    <!-- Acquired Skills -->
                                    <h6>{{ 'Acquired Skills' | translate }}</h6>
                                    <div>
                                      <div *ngIf="job.acquired_skills?.length > 0; else noAcquiredSkills">
                                        <div *ngFor="let skill of job.acquired_skills" class="d-flex align-items-center">
                                          <i class="fas fa-check-circle text-info mr-2"></i>&nbsp;
                                          <span>{{ skill.name }}</span>
                                        </div>
                                      </div>
                                      <ng-template #noAcquiredSkills>
                                        <p class="text-muted">{{ 'No skills found' | translate }}</p>
                                      </ng-template>
                                    </div>
                                
                                    <!-- Skills Gap -->
                                    <h6>{{ 'Skills Gap' | translate }}</h6>
                                    <div>
                                      <div *ngIf="job.skills_gap?.length > 0; else noSkillsGap">
                                        <div *ngFor="let skill of job.skills_gap" class="d-flex align-items-center">
                                          <i class="fas fa-exclamation-circle text-danger mr-2"></i>&nbsp;
                                          <span>{{ skill.name }}</span>
                                        </div>
                                      </div>
                                      <ng-template #noSkillsGap>
                                        <p class="text-muted">{{ 'No skills found' | translate }}</p>
                                      </ng-template>
                                    </div>
                                  </div>
                                </div>                                
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                    <!-- Additional Charts -->
                    <div class="col-md-6 mt-2">
                      <div *ngIf="skillGaphChartOptions" class="kpi-card">
                          <apx-chart [series]="skillGaphChartOptions.series" [chart]="skillGaphChartOptions.chart"
                              [xaxis]="skillGaphChartOptions.xaxis" [yaxis]="skillGaphChartOptions.yaxis"
                              [dataLabels]="skillGaphChartOptions.dataLabels" [title]="skillGaphChartOptions.title"
                              [colors]="skillGaphChartOptions.colors">
                          </apx-chart>
                      </div>
                    </div>
                    <div class="col-md-6 mt-2">
                        <div *ngIf="radarChartOptions" class="kpi-card">
                            <apx-chart [series]="radarChartOptions.series" [chart]="radarChartOptions.chart"
                                [xaxis]="radarChartOptions.xaxis" [yaxis]="radarChartOptions.yaxis"
                                [dataLabels]="radarChartOptions.dataLabels" [title]="radarChartOptions.title">
                            </apx-chart>
                        </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
